/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [dialog-box.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.01.20, 17:56
 */

import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import {useLanguage} from "../configuration/configuration";
import {Close} from "@material-ui/icons";

const DialogBox = ({children, className, isOpen=true,  setIsOpen,
                       action, isDisabled = false, callback=null,
                       data= null,  wide, title,
                       cancelButton = true,
                       root = '#root'}) => {
    const Lang = useLanguage();

    useEffect(() => {
        Modal.setAppElement(root);  // default is '#root'
    }, []);

    const handleOnClick = (event) => {
        callback(event, data);
        setIsOpen(false);
    }

    const handleOnClose = (event) => {
        event.preventDefault();
        setIsOpen(false);
    }

    return <Modal isOpen={isOpen}
                       onRequestClose={handleOnClose}
                       className={`standard-dialog-box ${wide ? 'dialog-box-wide' : ''} ${className ? className : ''}`}
                       overlayClassName="standard-dialog-box-overlay">

        <div className='dialog-box-container'>
            <div className='dialog-box-header'>
                <span className='dialog-box-title'>{title}</span>
                <span className='btn btn-outline-primary dialog-box-close-btn' onClick={handleOnClose}>
                    <Close/>
                </span>
            </div>

            <div className='dialog-box-content'>
                {children}
            </div>

            <div className='dialog-box-footer'>
                {cancelButton &&
                    <button className='btn btn-primary'
                            onClick={handleOnClose}>
                        {Lang.dialog.cancel}
                    </button>}
                {callback &&
                    <button className='btn btn-primary' disabled={isDisabled}
                            onClick={handleOnClick}>
                        {action}
                    </button>}
            </div>
        </div>
    </Modal>
};

export default DialogBox;